
export function isNotVacioNull(value, minmax = false, min = null, max = null,required = true) {

    //if (value == null) return false;
    // if (!value.trim()) return false;
    if (value == null) {
        return false;
    } else {
        if (!value.toString().trim()) return false;
        if (minmax) {
            if (value.toString().trim().length >= min && value.toString().trim().length <= max) {
                return true;
            } else {
                return false;
            }

        } else {
            return true;
        }
    }

}

export function isEmail(value, minmax = false, min = null, max = null, required = true) {

    //if (!/\S+@\S+\.\S+/.test(value)) return false;

    if (!required) {
        if (value !== null && value.toString().trim().length > 0) {
            required = true;
        } else {
            return true;
        }
    }

    if (required) {
        if (value == null) return false;
        if (/^[a-zA-Z0-9_.\-]+@[a-zA-Z0-9\-]+\.[a-zA-Z0-9_.\-]+$/.test(value)) {
            if (minmax) {
                if (value.toString().trim().length >= min && value.toString().trim().length <= max) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }

        } else {
            return false;
        }

    }

}

export function isValue(value, minmax = false, min = null, max = null,required = true) {
    return true;
}

export function isNumerico(value, minmax = false, min = null, max = null, required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;
    if (value == null) return false;
    if (value.toString().trim()==='') return false;
    if (/^([0-9])*$/.test(value)) return true;
    return false;
}

export function isLetras(value, minmax = false, min = null, max = null, required = true) {
    // Verificar si el valor es nulo o está vacío si es requerido
    if (required && (value == null || value.trim() === "")) return false;
    
    // Expresión regular que acepta letras, tildes, espacios, ñ y Ñ
    const regex = /^[a-zA-Z\u00C0-\u00FF\sñÑ]+$/;
    
    if (regex.test(value)) {
        if (minmax) {
            const length = value.trim().length;
            if (length >= min && length <= max) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }
    } else {
        return false;
    }
}

export function isLetras2Des(value, minmax = false, min = null, max = null,required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;
    // if (/^[a-zA-Z\u00C0-\u017F]+$/.test(value)) return true;
    // return false
    if (value == null) return false;
    if (/^[a-zA-Z\u00C0-\u017F]+$/.test(value)) {
        if (minmax) {
            if (value.toString().trim().length >= min && value.toString().trim().length <= max) {
                return true;
            } else {
                return false;
            }
        } else {
            return true;
        }

    } else {
        return false;
    }

}

export function isLetrasEspacio(value, minmax = false, min = null, max = null, required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;
    // if (/^[a-zA-Z\u00C0-\u017F]+$/.test(value)) return true;
    // return false

    if (!required) {
        if (value !== null && value.toString().trim().length > 0) {
            required = true;
        } else {
            return true;
        }
    }

    if (required) {
        if (value == null) return false;
        if (/^[a-zA-Z\s\u00C0-\u017F]+$/.test(value)) {
            if (minmax) {
                if (value.toString().trim().length >= min && value.toString().trim().length <= max) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }

        } else {
            return false;
        }
    }

}

export async function minMax(value, minmax = false, min = null, max = null, required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;

    if (value == null) return false;
    if (!value.toString().trim()) return false;
    if (value.trim().length >= min && value.trim().length <= max) return true;
    return false;
}

export function isRun(value, minmax = false, min = null, max = null, required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;
    if (/^\d{1,2}.\d{3}.\d{3}-(\d|K)$/.test(value)) {
        return checkRut(value);
    } else {
        return false;
    }

}

export function isTelefono(value, minmax = false, min = null, max = null, required = true) {
    //if (!/\S+@\S+\.\S+/.test(value)) return false;

    if (!required) {
        if (value !== null && value.toString().trim().length > 0) {
            required = true;
        } else {
            return true;
        }
    }

    if (required) {
        if (/^\+?(\d)*$/.test(value)) {
            if (minmax) {
                if (value.toString().trim().length >= min && value.toString().trim().length <= max) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }

        } else {
            return false;
        }
    }

}

export function getResultValidar(data, dataValidar) {

    let keys = Object.keys(data);
    let values = Object.values(data);
    let registra = true;

    let validarData = { ...dataValidar };
    //debugger;

    keys?.map((key, index) => {

        let validar = validarData[`${key}`];

        if (validar !== undefined) {
            if (key == 'provincia') {
                //  debugger;
            }

            if (values[index] instanceof Date) {
                validar.estado = true;
            } else {

                if (values[index] instanceof Object) {

                    if (Object.values(values[index])[0] == null) {
                        validar.estado = false;
                    } else {
                        if (!Object.values(values[index])[0].toString().trim()) {
                            validar.estado = false;
                        } else {
                            validar.estado = true;
                        }

                    }

                } else {

                    validar.estado = validar.validar(values[index], validar.minmax ? validar.minmax : false, validar.minmax ? validar.min : null, validar.minmax ? validar.max : null,validar.required);
                }

            }

            if (!validar.estado) {
                registra = false
            }
            validarData[`${key}`] = validar;

        }



    });

    return { result: validarData, registra: registra }

}

function checkRut(rut) {
    // debugger;
    rut = String(rut);
    let valor = rut.replace(".", "").replace(".", "");
    valor = valor.replace("-", "");
    let cuerpo = valor.slice(0, -1);
    let dv = valor.slice(-1).toUpperCase();
    rut = cuerpo + "-" + dv;
    if (cuerpo.length < 7) {
        return false;
    }
    let suma = 0;
    let multiplo = 2;
    for (let i = 1; i <= cuerpo.length; i++) {
        let index = multiplo * valor.charAt(cuerpo.length - i);
        suma = suma + index;
        if (multiplo < 7) {
            multiplo = multiplo + 1;
        } else {
            multiplo = 2;
        }
    }
    let dvEsperado = 11 - suma % 11;
    dv = dv == "K" ? 10 : dv;
    dv = dv == 0 ? 11 : dv;
    if (dvEsperado != dv) {
        return false;
    }
    return true;
}

export function inputTextValidate(value) {
    if (value === null) return true;
    if (!value.toString().trim()) return true;
    /*
    if (/\w|Á|É|Í|Ó|Ú|Ñ|\º|\\n|\"|\“|\”|\-|\_|\*|\s|\,|\.|\:|\(|\)|\ñ|á|é|í|ó|ú|\'|\$|@|%|#|;|=|\$|%|&|@|\+|\&|<|>/.test(value)) {
        return true;
    }else{
        return false;
    }
*/
    return true;
    
}





